import React from 'react';
import { Input, InputWithError, ErrorMessage, Label, InputGroup } from './styles';

interface FormInputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  errorMessage?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  hasError = false,
  errorMessage
}) => {
  return (
    <InputGroup>
      <Label>{label}</Label>
      <InputWithError>
        <Input
          type={type}
          placeholder={placeholder}
          value={value}
          $hasError={hasError}
          onChange={(e) => onChange(e.target.value)}
        />
        {hasError && errorMessage && (
          <ErrorMessage>
            {errorMessage}
          </ErrorMessage>
        )}
      </InputWithError>
    </InputGroup>
  );
};